function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_101",
  "data-name": "Path 101",
  d: "M262.76,92.721v42.96s-2.05.906-5.732,2.465c-9.5,4.025-29.892,12.385-54.172,20.819-40.257,13.959-91.237,28.111-121.1,22.884-21.814-3.816-38.416-15.518-50.5-28.244a135.752,135.752,0,0,1-23.745-34.9,10.361,10.361,0,0,1-.608-1.679,10.174,10.174,0,0,1,1.871-8.984l5.287-6.638,1.529-1.916a10.153,10.153,0,0,1,11.286-3.3,9.27,9.27,0,0,1,1.44.609c18.236,9.608,68.1,32.744,124.292,32.016,23.314-.3,77.872-22.364,100.28-31.838C259.033,94.369,262.76,92.721,262.76,92.721Z",
  transform: "translate(-0.594 -32.458)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_102",
  "data-name": "Path 102",
  d: "M263.509,92.721c-12.934,24.072-31.437,34.332-36.486,36.174q-14.591,5.3-28.155,8.895C99.2,164.355,41.728,125.925,20.908,107.318c-2.6-2.346-4.633-4.366-6.1-5.911l1.529-1.916A10.153,10.153,0,0,1,27.62,96.2a9.27,9.27,0,0,1,1.44.609c18.236,9.608,68.1,32.744,124.292,32.016,23.314-.3,77.872-22.364,100.28-31.838C259.781,94.369,263.509,92.721,263.509,92.721Z",
  transform: "translate(-1.342 -32.458)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_103",
  "data-name": "Path 103",
  d: "M249.291,228.092s-28.17,1.173-64.3,1.559h-.015c-58.835.624-138.786-.817-152.566-12.681a78.259,78.259,0,0,1-13.573-15.815c-1.128-1.663-2.2-3.356-3.223-5.079-1.128-1.9-2.212-3.816-3.237-5.732A183.145,183.145,0,0,1,.856,163.406c-.178-.5-.326-.98-.476-1.426a7.679,7.679,0,0,1,1.649-7.588l5.287-5.777,1.5-1.633a7.71,7.71,0,0,1,8.865-1.8c.356.164.727.326,1.084.49,4.039,1.827,8,3.49,11.895,5.019,78.585,30.947,131.94,6.683,166.867-15.815,13.825-8.895,24.754-17.523,33.234-22.334a74.589,74.589,0,0,0,21.5-18.458l.015-.015h.015a83.391,83.391,0,0,0,16.157-33.441l6.653,5.093,3.846,2.94s1.752,54.053,3.549,63.512v.015c.059.3.1.535.164.743C284.515,139.736,249.291,228.092,249.291,228.092Z",
  transform: "translate(0 -29.548)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_104",
  "data-name": "Path 104",
  d: "M311.8,183.452c-8.034,44.163-63.646,91.162-132.86,109.71-69.2,18.532-148.289-28.437-155.714-37.7-5.049-6.311-14.389-19.5-19.84-27.279A13,13,0,0,1,2.2,215.365l5.212-11.4a13,13,0,0,1,15.473-7.038c98.365,28.9,113.1,11.924,156.056,4.157,35.462-6.385,62.7-40.287,77.59-65.042,2.183-3.608,4.1-7.039,5.732-10.143,1.218-2.317,2.287-4.455,3.193-6.371,8.91-18.888,8.925-41.8,8.717-48.277v-.015c-.03-1.143-.075-1.767-.075-1.767h21.013s-10.5,27.19,0,50.058,24.724,19.765,16.691,63.928Z",
  transform: "translate(-0.094 -30.349)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_105",
  "data-name": "Path 105",
  d: "M283.225,132.979v.015c-7.692,35.1-29.239,71.724-81.2,91.757-5.539,2.139-10.975,4.025-16.305,5.7h-.015C96.742,258.3,35.888,224.142,15.53,209.767a87.379,87.379,0,0,1-7.485-5.806,13,13,0,0,1,15.473-7.038c98.365,28.9,113.1,11.924,156.056,4.157,35.462-6.385,62.7-40.287,77.59-65.042,2.183-3.608,4.1-7.039,5.732-10.143,1.218-2.317,2.287-4.455,3.193-6.371,8.91-18.888,8.925-41.8,8.717-48.277v-.015c-.03-1.143-.075-1.767-.075-1.767h10.276c2.3,16.764,3.415,39.8-1.782,63.512Z",
  transform: "translate(-0.729 -30.349)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Path_106",
  "data-name": "Path 106",
  d: "M275.83,65.725c-.178.95-.371,1.93-.594,2.94-.134.579-.267,1.173-.43,1.782A111.152,111.152,0,0,1,262.9,99.107c-11.152,19.26-30.011,40.436-59.9,56.948h-.015a217.354,217.354,0,0,1-55.493,20.893C70.741,195.021,28.093,166.688,13.674,154.125a54.51,54.51,0,0,1-5.628-5.51l1.5-1.633a7.71,7.71,0,0,1,8.865-1.8c.356.164.727.326,1.084.49,4.039,1.827,8,3.49,11.895,5.019,78.585,30.947,131.94,6.683,166.867-15.815,13.825-8.895,24.754-17.523,33.234-22.334a74.694,74.694,0,0,0,21.517-18.473h.015a83.392,83.392,0,0,0,16.157-33.441Z",
  transform: "translate(-0.73 -29.548)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  id: "Group_23",
  "data-name": "Group 23",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_107",
  "data-name": "Path 107",
  d: "M291.886,42.558l5.31-7.794c2.5-3.665,5.514-7.666,9.912-8.246,4.031-.532,7.8,2.055,10.7,4.9,2.387,2.338,17.622,1.794,19.435,4.6,2.892,4.477,5.025,9.8,4.154,15.06a11.144,11.144,0,0,1-2.431,5.478,18.175,18.175,0,0,1-5.026,3.655l-6.49,3.664c-4.07,2.3-8.2,4.618-12.716,5.813-4.95,1.309-10.509,1.121-14.847-1.6-4.076-2.557-7.381-8.283-5.139-12.955,2.642-5.505-6.3-7.539-2.864-12.576Z",
  transform: "translate(-26.396 -26.448)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_108",
  "data-name": "Path 108",
  d: "M26.873,96.486c.208,4.247-3.534,8.138-6.712,11.123-.386.356-.743.7-1.1,1.025-3.134,2.911-7.544,4.826-10.484,7.766-.549.326-1.114.638-1.678.92a10.174,10.174,0,0,1,1.871-8.984l5.287-6.638,1.529-1.916A10.151,10.151,0,0,1,26.873,96.486Z",
  transform: "translate(-0.594 -32.748)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_109",
  "data-name": "Path 109",
  d: "M18.765,154.038c-.713,3.164-3.341,6.073-5.821,8.449-.624.609-1.232,1.158-1.8,1.693C8.072,167.031,3.8,168.917.856,171.769c-.178-.5-.326-.98-.476-1.426a7.679,7.679,0,0,1,1.649-7.588l5.287-5.777,1.5-1.633a7.71,7.71,0,0,1,8.865-1.8C18.036,153.712,18.407,153.875,18.765,154.038Z",
  transform: "translate(0 -37.911)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_110",
  "data-name": "Path 110",
  d: "M18.932,214.612a42.164,42.164,0,0,1-3.594,7.084c-.148.252-.3.49-.446.727-2.2,3.385-5.524,6.3-7.365,9.726A16.3,16.3,0,0,1,3,235.818a7.725,7.725,0,0,1-1.6.594,12.91,12.91,0,0,1,.8-8.39l5.212-11.4a12.993,12.993,0,0,1,12.221-7.558,11.186,11.186,0,0,1-.7,5.554Z",
  transform: "translate(-0.094 -43.006)",
  fill: "rgba(147,147,147,0.69)"
}));

function SvgBanana(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "banana",
    xmlns: "http://www.w3.org/2000/svg",
    width: 315.2,
    height: 267.101,
    viewBox: "0 0 315.2 267.101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanana);
export default __webpack_public_path__ + "static/media/banana.ae88ba49.svg";
export { ForwardRef as ReactComponent };